import React, { useState, useEffect } from 'react';
import { GetLabDetails, EditLabDetails } from '../../Services/Authservices';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Select, 
  MenuItem, 
  IconButton,
  Button
} from '@mui/material';

const EditLab = () => {
  const labId = sessionStorage.getItem('LabID');

  const [formData, setFormData] = useState({
    LaboratoryID: labId || 0,
    LaboratoryName: '',
    LaboratoryContactNumber: '',
    LaboratoryEmail: '',
    LaboratoryAddress: ''
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  // Fetch Lab Details on mount
  useEffect(() => {
    const fetchLab = async () => {
      try {
        setLoading(true);
        const data = await GetLabDetails(labId);
        setFormData({
          LaboratoryID: data.laboratoryID || data.LaboratoryID || labId,
          LaboratoryName: data.laboratoryName || data.LaboratoryName || '',
          LaboratoryContactNumber: data.laboratoryContactNumber || data.LaboratoryContactNumber || '',
          LaboratoryEmail: data.laboratoryEmail || data.LaboratoryEmail || '',
          LaboratoryAddress: data.laboratoryAddress || data.LaboratoryAddress || ''
        });
      } catch (error) {
        setMessage({
          type: 'error',
          text: error?.response?.data?.message || 'Failed to fetch lab details.'
        });
      } finally {
        setLoading(false);
      }
    };

    if (labId) {
      fetchLab();
    }
  }, [labId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await EditLabDetails(formData);
      setMessage({
        type: 'success',
        text: response?.message || 'Laboratory updated successfully!'
      });
    } catch (error) {
      setMessage({
        type: 'error',
        text: error?.response?.data?.message || 'Failed to update laboratory details.'
      });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="common-FontFamily common-FontSize-small p-4 text-center">Loading lab details...</div>;
  }

  return (
    <div className = "container-fluid Container2">
    <div className="container2 common-bg-white common-box-border common-box-shadow common-br-3px p-4 my-4 mx-auto" style={{ maxWidth: '500px' }}>
      <h5 className="common-FontFamily common-color commont-Font-Bold mb-3">Edit Laboratory</h5>

      {message.text && (
        <div
          className={`common-FontFamily common-FontSize-small p-2 mb-3 common-br-3px ${
            message.type === 'success' ? 'alert alert-success' : 'alert alert-danger'
          }`}
        >
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="common-Labels d-block mb-1">
            Laboratory Name <span className="common-Asterisk">*</span>
          </label>
          <input
            type="text"
            name="LaboratoryName"
            className="form-control common-Input"
            value={formData.LaboratoryName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="common-Labels d-block mb-1">
            Contact Number <span className="common-Asterisk">*</span>
          </label>
          <input
            type="text"
            name="LaboratoryContactNumber"
            className="form-control common-Input"
            value={formData.LaboratoryContactNumber}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="common-Labels d-block mb-1">
            Laboratory Email <span className="common-Asterisk">*</span>
          </label>
          <input
            type="email"
            name="LaboratoryEmail"
            className="form-control common-Input"
            value={formData.LaboratoryEmail}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="common-Labels d-block mb-1">
            Laboratory Address <span className="common-Asterisk">*</span>
          </label>
          <textarea
            name="LaboratoryAddress"
            className="form-control common-Textarea"
            value={formData.LaboratoryAddress}
            onChange={handleChange}
            rows={3}
            required
          />
        </div>

        <div className="common-text-end mt-4">
          <Button
            type="submit"
            disabled={saving}
            variant="contained"
            className=" common-button common-FontFamily common-FontSize-small"
          >
            {saving ? 'Saving...' : 'Update Laboratory'}
          </Button>
        </div>
      </form>
    </div>
    </div>
  );
};

export default EditLab;